<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Search Intuit Customers</v-card-title>

        <v-card-text>
            
            <v-text-field
                label="Partial Company Name"
                hint="You must click the search button to see results"
                v-model="full_text"
                autofocus
                autocomplete="off"
            >
                <v-icon 
                    slot="append" 
                    style="pointer-events: auto;"
                    v-on:click="onClickSearch"
                    v-if="!searching"
                >
                    mdi-magnify
                </v-icon>

                <v-progress-circular
                    slot="append-outer" 
                    :size="24"
                    :width="3"
                    color="primary"
                    indeterminate
                    v-if="searching"
                >
                </v-progress-circular>

            </v-text-field>

            <v-list-item
                v-for="(item, index) in results"
                :key="index"
            >
                <v-list-item-content
                    v-on:click="onClickCustomer(item)"
                    style="cursor: pointer"
                >
                    <v-list-item-title>{{item.company_name}}</v-list-item-title>
                    <v-list-item-subtitle>{{item.id}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>


        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            full_text: '',
            results: [],
            searching: false,
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
            this.full_text = '';
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickSearch()
        {
            this.searching = true;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/intuit/customers',
            
                'params' : {
                        'full_text' : this.full_text,
                    },
            
                'on_success': (data) => {
                         this.searching = false;
                        this.results = data.results;
                    },
            
                'on_error': () => {
                     this.searching = false;
                    this.$rc.alert('Error','Unable to search intuit customers');
                },
            });
        },

        onClickCustomer(item)
        {
            this.$emit('input',item);
            this.onCancel();
        }

    },
}
</script>

<style lang="scss" scoped>
</style>